import { ChangeDetectionStrategy, Component } from '@angular/core';
import { DynamicRedactedBaseComponent } from '@ups/xplat/dynamic-render';

@Component({
  selector: 'ups-dynamic-redacted',
  templateUrl: 'dynamic-redacted.component.html',
  // WI 35584: base-class marks cover async writes; ngDoCheck covers in-place config flags.
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class DynamicRedactedComponent extends DynamicRedactedBaseComponent {}
